import { SignedIn, SignedOut } from '@clerk/clerk-react'
import { Link } from 'react-router-dom'
import { Card } from '../components/ui'

export function MarketingPage() {
  return (
    <div className="shell">
      <header className="shell__bar">
        <Link to="/" className="wordmark">
          detach<span>ly</span>
        </Link>
        <nav className="shell__nav" aria-label="Main" />
        <SignedOut>
          <Link to="/sign-in" className="shell__link">
            Sign in
          </Link>
          <Link to="/sign-up" className="button">
            Get started
          </Link>
        </SignedOut>
        <SignedIn>
          <Link to="/app/projects" className="button">
            Open dashboard
          </Link>
        </SignedIn>
      </header>

      <main className="shell__main">
        <section className="hero">
          <h1>Take your content out of Framer, and your code with it.</h1>
          <p>
            Detachly connects to your own Framer project, reads what is actually there, and hands
            you an export pack: every page, every CMS item, your colors and fonts — as JSON, CSV and
            a React project you own. No Framer runtime, no lock-in, no invented content.
          </p>
          <div className="row">
            <SignedOut>
              <Link to="/sign-up" className="button">
                Connect a project
              </Link>
            </SignedOut>
            <SignedIn>
              <Link to="/app/projects" className="button">
                Go to your projects
              </Link>
            </SignedIn>
            <Link to="/sign-in" className="button button--secondary">
              I already have an account
            </Link>
          </div>
        </section>

        <section className="grid">
          <Card>
            <div className="card__title">
              <h2>Scan — free</h2>
            </div>
            <p className="muted">
              We open your project with your own Framer API key and count what is inside: routes,
              collections, items, colors, fonts. You see the inventory before you decide anything.
            </p>
          </Card>
          <Card>
            <div className="card__title">
              <h2>Content Pack — free</h2>
            </div>
            <p className="muted">
              Every collection as JSON and CSV, absolute image URLs, design tokens and a README,
              zipped. It is your content, in formats anything can read.
            </p>
          </Card>
          <Card>
            <div className="card__title">
              <h2>React project — free scaffold</h2>
            </div>
            <p className="muted">
              A Vite + React app wired to your content, ready to run. It is a reconstruction, not a
              pixel-perfect copy of your Framer site — and we tell you exactly where it differs.
            </p>
          </Card>
        </section>
      </main>
    </div>
  )
}
